import Hls from 'hls.js/dist/hls.min.js';
import Plyr from 'plyr/dist/plyr.polyfilled.js';
Plyr.setup('.plyr');
var Video = /** @class */ (function () {
    function Video(video, options) {
        this.video = video;
        this.autoplay = options.autoplay || false;
        this.adaptiveStreaming = options.adaptiveStreaming || false;
        var srcHls = this.video.getAttribute('data-src-hls');
        if (this.adaptiveStreaming && Hls.isSupported() && srcHls) {
            this.initAdaptiveStreaming(srcHls);
        }
        else {
            if (this.autoplay) {
                this.forcePlay();
            }
        }
    }
    Video.prototype.initAdaptiveStreaming = function (srcHls) {
        var _this = this;
        var hlsVideo = new Hls({
            startLevel: 2,
            minAutoBitrate: 1135000,
            autoStartLoad: this.autoplay,
        });
        hlsVideo.attachMedia(this.video);
        hlsVideo.loadSource(srcHls);
        hlsVideo.on(Hls.Events.MANIFEST_PARSED, function () {
            if (_this.autoplay) {
                _this.forcePlay();
            }
        });
        hlsVideo.on(Hls.Events.LEVEL_SWITCHING, function (event, data) {
            var videoParentEl = _this.video.parentElement;
            if (videoParentEl) {
                var playerWidth_1 = videoParentEl.clientWidth || document.documentElement.clientWidth;
                var viableLevels = hlsVideo.levels.filter(function (level) { return level.width <= playerWidth_1; });
                var maxViableLevel = Math.max(viableLevels.length, 2);
                console.log("HLS: Request quality ".concat(data.level, " (max: ").concat(maxViableLevel, " / ").concat(playerWidth_1, "px)"));
                hlsVideo.autoLevelCapping = maxViableLevel;
            }
        });
        hlsVideo.on(Hls.Events.LEVEL_SWITCHED, function (event, data) {
            console.log("HLS: Changed quality to ".concat(data.level));
        });
        hlsVideo.on(Hls.Events.ERROR, function (event, data) {
            if (data.fatal) {
                switch (data.type) {
                    case Hls.ErrorTypes.NETWORK_ERROR:
                        console.log("HLS: Fatal network error encountered, try to recover");
                        hlsVideo.startLoad();
                        break;
                    case Hls.ErrorTypes.MEDIA_ERROR:
                        console.log("HLS: Fatal media error encountered, try to recover");
                        hlsVideo.recoverMediaError();
                        break;
                    default:
                        console.log("HLS: Fatal media error encountered, cannot recover");
                        hlsVideo.destroy();
                        break;
                }
            }
        });
        this.video.addEventListener('play', function () {
            hlsVideo.startLoad();
        });
    };
    Video.prototype.forcePlay = function () {
        this.video.volume = 0;
        this.video.muted = true;
        var playPromise = this.video.play();
        if (typeof playPromise !== 'undefined') {
            playPromise.catch(function (err) {
                // ignore errors
            });
        }
    };
    return Video;
}());
export { Video };
